import { SmartAssistant } from 'shared/interfaces/SmartAssistant';
import {
  AddWhiteLabelDomainDto,
  AddWhiteLabelSubDomainDto,
  DeleteWhiteLabelSubDomainDto,
  UpdateWhiteLabelDomainAndSmartAssistantAssociationDto,
  WhiteLabelDomain
} from 'shared/interfaces/WhiteLabelDomain';
import { axiosBaseInstance } from 'shared/utils/axios-instances';

const whiteLabelEndpoint = '/white-label';

export const WhiteLabelService = {
  addWhiteLabelSubDomain: async (addWhiteLabelSubDomainDto: AddWhiteLabelSubDomainDto): Promise<WhiteLabelDomain> => {
    const response = await axiosBaseInstance({
      method: 'post',
      url: `${whiteLabelEndpoint}/sub-domain`,
      data: addWhiteLabelSubDomainDto
    });

    return response.data;
  },
  addWhiteLabelDomain: async (addWhiteLabelDomainDto: AddWhiteLabelDomainDto): Promise<WhiteLabelDomain> => {
    const response = await axiosBaseInstance({
      method: 'post',
      url: `${whiteLabelEndpoint}`,
      data: addWhiteLabelDomainDto
    });

    return response.data;
  },
  deleteWhiteLabelSubDomain: async (
    deleteWhiteLabelDomainDto: DeleteWhiteLabelSubDomainDto
  ): Promise<WhiteLabelDomain> => {
    const response = await axiosBaseInstance({
      method: 'delete',
      url: `${whiteLabelEndpoint}/sub-domain`,
      data: deleteWhiteLabelDomainDto
    });

    return response.data;
  },
  deleteWhiteLabelDomain: async (id: string): Promise<WhiteLabelDomain> => {
    const response = await axiosBaseInstance({
      method: 'delete',
      url: `${whiteLabelEndpoint}/${id}`
    });

    return response.data;
  },
  getAllWhiteLabelDomains: async (): Promise<WhiteLabelDomain[]> => {
    const response = await axiosBaseInstance({
      method: 'get',
      url: `${whiteLabelEndpoint}/all`
    });

    return response.data;
  },
  getWhiteLabelDomainById: async (id: string): Promise<WhiteLabelDomain> => {
    const response = await axiosBaseInstance({
      method: 'get',
      url: `${whiteLabelEndpoint}/${id}`
    });

    return response.data;
  },
  refreshWhiteLabelDomain: async (id: string): Promise<WhiteLabelDomain> => {
    const response = await axiosBaseInstance({
      method: 'get',
      url: `${whiteLabelEndpoint}/refresh/${id}`
    });

    return response.data;
  },
  retryWhiteLabelDomain: async (id: string): Promise<WhiteLabelDomain> => {
    const response = await axiosBaseInstance({
      method: 'put',
      url: `${whiteLabelEndpoint}/retry/${id}`
    });

    return response.data;
  },
  updateWhiteLabelDomainAndSmartAssistantAssociation: async (
    updateWhiteLabelDomainAndSmartAssistantAssociationDto: UpdateWhiteLabelDomainAndSmartAssistantAssociationDto
  ): Promise<SmartAssistant> => {
    const response = await axiosBaseInstance({
      method: 'put',
      url: `${whiteLabelEndpoint}/update-with-smart-assistant`,
      data: updateWhiteLabelDomainAndSmartAssistantAssociationDto
    });

    return response.data;
  }
};
